<template>
  <div style="height: 100%;background-color: #fbfbfb;padding-top: 20px;box-sizing: border-box">
    <div style="height: 50px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="add()">新增</el-button>&nbsp;
    </div>
    <div style="height: calc(100% - 70px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" v-loading="loading" element-loading-text="加载中，请耐心等待。"
                border style="width: 100%" highlight-current-row ref="singleTable" height="100%">
        <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
        <el-table-column prop="org_name" label="所属组织" min-width="80" align="center"></el-table-column>
        <el-table-column prop="good_name" label="权益包名称" min-width="80" align="center"></el-table-column>
        <el-table-column label="权益包内容" min-width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.showGood.includes.length > 0" style="background: #EBF2FA;padding: 10px;box-sizing: border-box;border-radius: 10px;color: #1A1A1A;margin-top: 10px;letter-spacing: 1px">
              <div v-for="(item, index) in scope.row.showGood.includes" :key="index">
                <div style="min-height: 40px;display: flex;border-bottom: 1px solid #cbcbcb;margin-top: 10px">
                  <div style="flex: 1" v-if="item.type === 'coupon'">
                    <span>{{item.category}}{{item.face_value / 100}}元{{item.title}}</span>
                  </div>
                  <div style="flex: 1" v-if="item.type === 'device'">
                    <span>{{item.title}}价值{{item.estimated_value / 100}}元</span>
                  </div>
                  <div style="flex: 1" v-if="item.type === 'service'">
                    <div style="height: 24px"><span>{{item.title}}价值{{item.value / 100}}元</span></div>
                    <div style="height: 40px;color: #7e7d7d"><span>{{item.note}}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="create_tm" label="录入时间" min-width="110" align="center"></el-table-column>
        <el-table-column label="图片" min-width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.showGood && scope.row.showGood.fileurl !== ''" style="color: blue" @click="handlePictureCardPreview(scope.row.showGood.fileurl)">查看</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="140">
          <template slot-scope="scope">
            <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="edit(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="del(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
<!--    <div style="margin-top: 10px;height: 40px;text-align: center">-->
<!--      <el-pagination v-fixZoom-->
<!--                     @size-change="handleSizeChange"-->
<!--                     @current-change="handleCurrentChange"-->
<!--                     :current-page="currentPage"-->
<!--                     :page-sizes="[10, 20, 50, 100]"-->
<!--                     :page-size="pageSize"-->
<!--                     layout="total, sizes, prev, pager, next, jumper"-->
<!--                     :total="totalCells">-->
<!--      </el-pagination>-->
<!--    </div>-->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="700px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{ addEditTitle }}</span> </div>
        <div class="line-title"></div>
      </div>
      <add-edit-project :addEditRow="addEditRow" v-model="addEditShow" @changeData="changeData"></add-edit-project>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="800px" append-to-body>
      <div style="text-align: center">
        <img style="max-width: 100%" :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>
  </div>
</template>
<script>
import addEditProject from './businessComponents/addEditProject.vue'
import addEditUser from './businessComponents/addEditUser.vue'
import {minigoodsList, minigoodsDelete} from '../../api/project'
import {queryorg} from '../../api/organizer'
import {querysuppliertype} from '../../api/serviceMark'
export default {
  name: 'projectSet',
  components: {addEditUser, addEditProject},
  data () {
    return {
      loading: false,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addEditShow: false,
      addEditTitle: '',
      addEditRow: {
        isAdd: true,
        orgData: [],
        types: [],
        row: ''
      },
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  created () {
    this.querySupplierTypeData()
    this.getOrgData()
    this.getTableData()
  },
  methods: {
    // 服务类型
    querySupplierTypeData () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.addEditRow.types = res.data.types
      }).catch(() => {})
    },
    handlePictureCardPreview (fileurl) {
      this.dialogImageUrl = fileurl
      this.dialogVisible = true
    },
    // 组织
    getOrgData () {
      queryorg().then(res => {
        this.addEditRow.orgData = res.data.org
      }).catch(() => {})
    },
    changeData () {
      this.getTableData()
    },
    getTableData () {
      this.loading = true
      minigoodsList().then(res => {
        let arr = []
        res.data.goods.forEach(item => {
          item.showGood = item.good !== '' ? JSON.parse(item.good) : ''
          let url = (window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host) + '/api/v1/web/staticfile/file/'
          item.showGood.fileurl = ''
          console.log(item.showGood.filename)
          if (item.showGood.filename && item.showGood.filename !== '') {
            item.showGood.fileurl = url + item.showGood.filename
          }
          arr.push(item)
        })
        this.tableData = arr
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    add () {
      this.addEditTitle = '新增项目'
      this.addEditShow = true
      this.addEditRow.isAdd = true
    },
    edit (row) {
      this.addEditTitle = '更新项目'
      this.addEditShow = true
      this.addEditRow.isAdd = false
      this.addEditRow.row = row
    },
    del (row) {
      let name = row.good_name
      this.$confirm('此操作将永久删除该项目【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        minigoodsDelete(data).then(res => {
          this.$message.success('删除成功')
          this.getTableData()
        }).catch(() => {})
      }).catch(() => {})
    },
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
      // this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // this.getTableData()
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/businessWeChat/projectSet.vue